<template>
  <div class="wrap-b">
    <Spin
      fix
      class="ivu-spin-fullscreen"
      :class="{ 'dt-none': isLoading === false }"
    >
      <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
      <div>{{ loadingText }}</div>
    </Spin>
    <div class="map-layout">
      <header class="head-style">
        <span class="title-cont title-style bold">日期</span>
        <span class="title-cont title-style">{{ today }}</span>
        <span class="title-cont title-style bold">拜访客户数</span>
        <span class="title-cont title-style">{{ dayCust }}</span>
        <span class="title-cont title-style bold">预计行程</span>
        <span class="title-cont title-style">{{ totalKm }}</span>
        <span class="title-cont title-style bold" style="clear: left"
          >预计时长</span
        >
        <span class="title-cont title-style">{{ totalTime }}</span>
        <span class="title-cont title-style bold">预计开始时间</span>
        <span class="title-cont title-style">{{ startTime }}</span>
        <span class="title-cont title-style bold">预计结束时间</span>
        <span class="title-cont title-style">{{ endTime }}</span>
        <Button type="primary" class="btn-table" @click="clickShowCalendar">{{
          showCalendarName
        }}</Button>
        <Button
          type="primary"
          class="btn-table margin-right-10"
          @click="clickShowTab"
          >{{ shoTabName }}</Button
        >
      </header>
      <div class="right" v-show="showCalendar">
        <div class="visit-panel">
          <div class="select-user-panel select-condition">
            <div class="select-user-block">
              <span class="select-user-title">城市</span>
              <Select
                v-model="citySlect"
                class="select-user text-center margin-top-10"
                @on-change="changeCity(citySlect)"
              >
                <Option
                  v-for="city in cities"
                  :key="city.value"
                  :value="city.value"
                  >{{ city.label }}</Option
                >
              </Select>
            </div>
            <div class="select-user-block">
              <span class="select-user-title">业务员</span>
              <Select
                v-model="userSelect"
                class="select-user text-center margin-top-10"
                :label-in-value="true"
                @on-change="changeUser"
              >
                <Option
                  v-for="user in userAlls"
                  :key="user.label"
                  :value="user.value"
                  >{{ user.label }}</Option
                >
              </Select>
            </div>
          </div>
          <div id="calendar" class="margin-top-8"></div>
          <div class="current-month-num current-month-heitht">
            <p class="title">本月业务量</p>
            <div class="current-month-num-body">
              <div class="all-line-info font-bold">
                <span class="with-50">拜访用户数量</span>
                <span>{{ custCount }}</span
                >个
              </div>
              <Col
                class="all-line-info"
                v-for="(val, key, index) in levelCount"
                :key="index + '-' + key + '-' + val"
              >
                <span class="with-50">{{ key }}次客户</span>
                <span>{{ val }}</span
                >个
              </Col>

              <Col class="all-line-info font-bold">
                <span class="with-50">预计总行程</span>
                <span>{{ visitDistance }}</span>
              </Col>
              <Col class="all-line-info font-bold">
                <span class="with-50">预计总时长</span>
                <span>{{ visitDurction }}</span>
              </Col>
              <Col class="all-line-info font-bold">
                <span class="with-50">预计工作天数</span>
                <span>{{ visitDays }}</span
                >天
              </Col>
              <Col class="all-line-info font-bold">
                <span class="with-50">预计休息天数</span>
                <span>{{ restDays }}</span
                >天
              </Col>
            </div>
          </div>
          <div v-show="false" class="future-visit-panel height-295">
            <p class="title">未排入本月PJP的客户（{{ futureVisit.length }}）</p>
            <div class="future-visit-panel-body">
              <div class="visit-item" v-for="visit in futureVisit">
                <Col span="12" class="visit-custorm">{{
                  visit.attrs.CustomerName
                }}</Col>
                <Col span="12" class="add-daily" style="text-align: right">
                  <span>+</span>
                  加入日程
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="left"
        ref="mapPanel"
        :class="!showCalendar ? 'update-width' : ''"
      >
        <Table
          v-show="showTable"
          :columns="tableTitle"
          :data="tableItems"
          class="table-style"
        ></Table>
        <div id="mapContainer" class="map-style"></div>
      </div>
    </div>
  </div>
</template>
<script>
import "../assets/stylesheets/map_demo.scss";
import "../assets/stylesheets/calendar.css";
import "../assets/javascript/leaflet-baidu.js";
import "../assets/javascript/jquery.min.js";
import "../assets/javascript/calendal_demo.js";
// import "../assets/javascript/mapUtils.js";
import api from "../service/api";
import getData from "../service/getData";
import getColor from "../service/randomColor.js";
import moment from "moment";
import { setTimeout } from "timers";
import {
  initMap,
  openMarWindow,
  openLineWindow
} from "../assets/javascript/map.js";

export default {
  data: function() {
    return {
      isLoading: false,
      map: null,
      loadingText: "加载中...",
      userId: "",
      nickName: "",
      today: "",
      dayCust: 0,
      totalKm: "0km",
      totalTime: "0min",
      startTime: "00:00",
      endTime: "00:00",
      citySlect: "北京",
      mapConfig: {
        init_level: 13,
        init_center: "116.397389,39.908808",
        baseLayer: { style: "dark", type: "baidu" },
        getCoordinate: function() {
          return "baidu";
        }
      },
      cities: [
        {
          value: "北京",
          label: "北京"
        }
      ],
      tableTitle: [
        {
          title: "序号",
          key: "num",
          width: 60
        },
        {
          title: "客户名称",
          key: "name",
          width: 160,
          maxWidth: 1000
        },
        {
          title: "到达时间",
          key: "arriveTime",
          width: 90
        },
        {
          title: "离开时间",
          key: "leaveTime",
          width: 90
        }
      ],
      tableItems: [],
      userSelectName: "小明",
      userSelect: "region_0",
      // userAlls: demoUser.getUsers(),
      userAlls: [],
      currentUser: {},
      users: [],
      custCount: 0, //全部的客户数
      visitDistance: 0,
      visitDurction: 0,
      visitDays: 0,
      restDays: 0,
      futureVisit: [],
      layerGroup: new L.layerGroup(),
      pointsMap: new Map(), //全部的客户
      layerMap: new Map(), //用来存储现在显示的
      lineMap: new Map(), //保存每一天的线路信息
      levelKey: "level",
      levelCount: {},
      // allDays: {},
      changeMonth: true,
      showTable: false,
      showCalendar: true,
      showCalendarName: "隐藏日历",
      shoTabName: "展示列表",
      month: "2019-01",
      focusLayers: [], // 焦点图层
      focusLineLayer: null,
      focusMarker: null, // 焦点点位
      mashiObjectMap: {
        id: "编号",
        lat: "lat",
        lng: "lng",
        oneChannel: "一级渠道",
        twoChannel: "二级渠道",
        threeChannel: "三级渠道",
        businessName: "业务名称",
        businessNum: "业务工号",
        supplierName: "供货商名称",
        city: "城市",
        cityGroups: "城市群",
        bigRegion: "大区",
        province: "省份",
        bindTime: "绑定时间",
        address: "联系地址",
        shopName: "门店名称",
        shopNum: "门店编码",
        frm: "RFM频率",
        frequency: "RFM频率",
        staytime: "三级渠道"
      }
    };
  },
  computed: {},
  watch: {
    // allDays: {
    //   handler(newval) {
    //     console.warn("aaa");
    //     console.log(newval);
    //   },
    //   deep: true
    // }
  },
  mounted() {
    //初始化地图
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      this.$router.push({ path: "/demo-login" });
    }
    this.nickName = sessionStorage.getItem("nickname");
    this.userId = userId;
    this.map = initMap();
    this.map.on("popupclose", this.clearFocus);
    this.layerGroup.addTo(this.map);
    this.getRegions();
    this.getOption();
    this.month = moment().format("YYYY-MM");

    // window.MapUtils.init(this.mapConfig, this.mapInited);
  },
  methods: {
    // mapInited( m ) {
    //   this.map = m;
    //   this.map.on("popupclose", this.clearFocus);
    //   this.layerGroup.addTo(this.map);
    //   this.getRegions();
    //   this.getOption();
    //   this.month = moment().format("YYYY-MM");
    // },
    getOption: async function() {
      //获取参数设置
      const res = await getData.get(api.getOption, { userId: this.userId });
      if (res.data && res.data.status && res.data.data) {
        const option = res.data.data;
        const city = res.data.data.city;
        this.citySlect = city;
        this.cities = [
          {
            value: city,
            label: city
          }
        ];
      }
    },
    changeUser: function(obj) {
      this.userSelectName = obj.label;
      let value = obj.value;
      this.clearLayer();
      this.getRegionData(value);
    },
    /**
     * 焦点路线
     */
    setFocusLineLayer(layers, latLngs) {
      this.clearFocusLineLayer();
      for (let layer of layers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(999);
        }
      }
      if (!this.focusLineLayer) {
        this.focusLineLayer = L.polyline(latLngs, {
          color: "#ff0000",
          weight: 5
        });
      } else {
        this.focusLineLayer.setLatLngs(latLngs);
      }
      this.focusLineLayer.addTo(this.map).bringToFront();
      this.focusLayers = layers;
    },
    clearFocusLineLayer() {
      for (let layer of this.focusLayers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(0);
        }
      }
      this.focusLayers = [];
      if (this.focusLineLayer) {
        this.focusLineLayer.remove();
      }
    },
    clearLayer() {
      for (let layersGroup of this.layerMap.values()) {
        layersGroup.remove();
      }
    },
    clearFocus() {
      this.clearFocusLineLayer();
      this.clearFocusMarker();
    },
    /**
     * 点位焦点
     */
    setFocusMarker(e) {
      this.focusMarker = e.target;
      let dom = this.focusMarker.getElement();
      let className = dom.className;
      if (className.indexOf("focus-marker-point") === -1) {
        className += " focus-marker-point";
      }
      dom.className = className;
    },
    clearFocusMarker() {
      if (this.focusMarker) {
        let dom = this.focusMarker.getElement();
        if (dom !== null) {
          let className = dom.className;
          if (className.indexOf("focus-marker-point") > -1) {
            className = className.replace(" focus-marker-point", "");
          }
          dom.className = className;
        }
      }
      this.focusMarker = null;
    },
    clickShowTab: function() {
      this.showTable = !this.showTable;
      this.shoTabName =
        this.shoTabName === "展示列表" ? "隐藏列表" : "展示列表";
    },
    clickShowCalendar: function() {
      this.showCalendar = !this.showCalendar;
      this.showCalendarName =
        this.showCalendarName === "展示日历" ? "隐藏日历" : "展示日历";
      let self = this;
      setTimeout(function() {
        self.map.invalidateSize(true, { debounceMoveend: true });
      }, 100);
    },
    changeCity: function(city) {},
    getRegions: async function() {
      //获取用户列表
      const res = await getData.get(api.planDemoRegions, {
        userId: this.userId
      });
      if (res.data && res.data.status) {
        for (let i = 0; i < res.data.regions.length; i += 1) {
          const userInfo = res.data.regions[i];
          this.userAlls.push({
            value: userInfo.userId,
            label: userInfo.nickName
          });
          if (i === 0) {
            this.userSelect = userInfo.userId;
            this.getRegionData(this.userSelect);
          }
        }
      } else {
        // do nothing
      }
    },
    /**
     * 获取每个用户的排班详情
     */
    getRegionData: async function(userId) {
      const monthMoment = moment(`${this.month}`, "YYYY-MM");
      let startDay = monthMoment.startOf("month").format("YYYY-MM-DD");
      let endDay = monthMoment.endOf("month").format("YYYY-MM-DD");
      if (this.nickName === "玛氏") {
        startDay = "2020-03-01";
        endDay = "2020-04-30";
      }

      const res = await getData.get(api.planDemoData, {
        userId: userId,
        startDay,
        endDay
      });
      if (res.data && res.data.status) {
        const pointsAll = res.data.info.points_all;
        for (let pointInfo of pointsAll) {
          this.pointsMap.set(pointInfo.id, pointInfo);
          const getKey = pointInfo.attrs[this.levelKey];
          if (!getKey) continue;
          if (this.levelCount.hasOwnProperty(getKey)) {
            this.levelCount[getKey] += 1;
          } else {
            this.levelCount[getKey] = 1;
          }
        }
        this.custCount = pointsAll.length;

        this.restDays = 0;
        this.lineMap = new Map();
        this.layerMap = new Map();
        this.visitDays = 0;
        let distance = 0;
        let durction = 0;
        for (let line of res.data.info.line_info) {
          if (!line.isHoliday) {
            distance += line.planData.route.distance;
            durction += line.planData.route.duration;
            this.visitDays += 1;
          } else {
            this.restDays += 1;
          }
          this.lineMap.set(line.date, line.planData);
        }
        this.visitDistance = `${(distance / 1000).toFixed(2)} km`;
        this.visitDurction = `${(durction / 60).toFixed(2)} h`;

        this.drawAllData();
        const allDays = {};
        for (let [key, value] of this.lineMap) {
          key = moment(key, "YYYY-MM-DD").format("YYYYMMDD");
          allDays[key] = {
            orderCounts: value ? value.reachTimes.length : "holiday"
          };
        }
        this.createDataControl(allDays);
      }
    },
    drawAllData() {
      //步行:1 公交:2 驾车:3  公交+步行:21  公交+驾车+步行:231
      //画全部的信息
      for (let [key, value] of this.lineMap) {
        if (!value) continue;
        const color = getColor.getColor();
        const layers = [];

        for (let i = 0; i < value.reachTimes.length; i++) {
          const reachTimeInfo = value.reachTimes[i];
          const pointId = reachTimeInfo.orderId;
          const point = this.pointsMap.get(pointId);

          const divHtml = `<div class='way-points' style='background-color:${color}'>${i +
            1}</div>`;
          const wayDivIcon = new L.divIcon({
            html: divHtml,
            className: "leaflet-direction-icon"
          });
          let stayTime = point.attrs.staytime;
          let times = point.attrs.frequency;
          const dateString = point.attrs.dates.join(";");
          let reg = new RegExp(";", "g");
          let marPups = [];
          const self = this;
          if (this.nickName === "玛氏") {
            for (const key in point.attrs) {
              //循环遍历key
              if (key === "dates") continue;
              if (!self.mashiObjectMap.hasOwnProperty(key)) continue;
              marPups.push({
                name: self.mashiObjectMap[key],
                cont: point.attrs[key]
              });
            }
          } else if (this.nickName.includes("东鹏")) {
            marPups = [
              {
                name: "名称",
                cont: `${point.attrs["门店名称"]}`
              },
              {
                name: "组",
                cont: `${point.attrs["组"]}`
              },
              {
                name: "业务员手机号",
                cont: `${point.attrs["业务员手机号"]}`
              },
              {
                name: "职务",
                cont: `${point.attrs["职务"]}`
              },
              {
                name: "门店编号",
                cont: `${point.attrs["门店编号"]}`
              },
              {
                name: "联系人手机号",
                cont: `${point.attrs["联系人手机号"]}`
              },
              {
                name: "地址",
                cont: `${point.attrs["地址"]}`
              },
              {
                name: "客户等级",
                cont: `${point.attrs["客户等级"]}`
              }
            ];
          } else {
            marPups = [
              {
                name: "名称",
                cont: `${point.attrs.name}`
              },
              {
                name: "访问频率",
                cont: `${times}次/月`
              }
            ];
          }
          marPups = marPups.concat([
            {
              name: "预计到达",
              cont: `${reachTimeInfo.time}`
            },
            {
              name: "预计离开",
              cont: `${reachTimeInfo.leaveTime}`
            },
            {
              name: "停留时长",
              cont: `${stayTime}分钟`
            },
            {
              name: "拜访日期",
              cont: dateString.replace(reg, "<br/>")
            }
          ]);

          layers.push(
            L.marker([point.point.coordinates[1], point.point.coordinates[0]], {
              icon: wayDivIcon,
              draggable: true
            }).on("click", (e) => {
              openMarWindow(e, marPups, this.map);
              this.setFocusMarker(e);
            })
          );
          //***************画线***************/
          const route = value.route.path[i];
          if (route) {
            let vehicles = [];
            for (let vehstr of route.vehicle_types) {
              if (vehstr.type === 1) {
                vehicles.push({
                  name: "步行",
                  cont: `${vehstr.distance}米`
                });
              } else if (vehstr.type === 2) {
                vehicles.push({
                  name: "公交",
                  cont: vehstr.busName.replace(/\(.*?\)/g, "")
                });
              } else if (vehstr.type === 3) {
                vehicles.push({
                  name: "驾车",
                  cont: `${(vehstr.distance / 1000).toFixed(2)}公里`
                });
              } else if (vehstr.type === 4) {
                vehicles.push({
                  name: "自行车",
                  cont: `${vehstr.distance}米`
                });
              } else if (vehstr.type === 5) {
                vehicles.push({
                  name: "电动车",
                  cont: `${vehstr.distance}米`
                });
              }
            }
            const attrRoutes = [];
            attrRoutes.push({
              name: "分段名称",
              cont: `${i}-${i + 1}`
            });
            attrRoutes.push({
              name: "拜访日期",
              cont: key
            });
            attrRoutes.push({
              name: "分段里程",
              cont: `${route.distance}m`
            });
            attrRoutes.push({
              name: "花费时长",
              cont: route.duration
                ? `${route.duration.toFixed(2)}min`
                : `${0}min`
            });
            attrRoutes.push({
              name: "通勤方式",
              vehicles
            });
            const latLngs = [];
            const routes = route.path.split(";");
            for (let route of routes) {
              latLngs.push(route.split(",").reverse());
            }
            layers.push(
              L.polyline(latLngs, {
                color: color
              }).on("click", e => {
                openLineWindow(e, attrRoutes, this.map);
                this.setFocusLineLayer(layers, latLngs);
              })
            );
          }
        }
        const featureGroup = L.featureGroup(layers);
        // featureGroup.addTo(this.map);
        this.layerMap.set(key, featureGroup);
      }
    },
    createDataControl(dates, getDate) {
      //data有的时候就用这个日期
      let self = this;
      $("#calendar").calendar({
        ifSwitch: true, // 是否切换月份
        hoverDate: false, // hover是否显示当天信息
        backToday: false, // 是否返回当天
        selected_data: self.today.replace(/-/g, ""),
        dates,
        afterInit: function(today) {
          if (today) {
            self.today = today;
          }
          self.getDayInfo(getDate ? getDate : self.today); //设置当天点线
          self.setDayInfo(getDate ? getDate : self.today); //展示当天基本信息
        },
        onMonthChange: function(date) {
          //*切换月份重新请求
          self.clearLayer();
          const monthString = moment(date).format("YYYY-MM");
          self.month = monthString;
          if (this.nickName !== "玛氏") self.getRegionData(self.userSelect);
        },
        onClick: function(today, selectDay) {
          self.today = selectDay;
          self.getDayInfo(selectDay);
          self.setDayInfo(selectDay);
        }
      });
    },
    getDayInfo: async function(date) {
      this.clearLayer();
      if (this.layerMap.has(date)) {
        this.layerMap.get(date).addTo(this.map);
        this.map.fitBounds(this.layerMap.get(date).getBounds());
      }
    },
    setDayInfo: function(date) {
      //设置当前天数展示的信息
      if (this.lineMap && this.lineMap.has(date)) {
        const getDateInfo = this.lineMap.get(date);
        if (!getDateInfo) return;

        this.dayCust = getDateInfo.reachTimes.length;
        this.totalKm = `${(getDateInfo.route.distance / 1000).toFixed(2)}km`;

        this.totalTime = `${(getDateInfo.route.duration / 60).toFixed(2)}h`;
        this.startTime = getDateInfo.reachTimes[0].time;
        this.endTime = _.last(getDateInfo.reachTimes).leaveTime;

        // const routeInfo = getDateInfo.route;

        this.tableItems = [];

        for (let i = 0; i < getDateInfo.reachTimes.length; i++) {
          const reachTimeInfo = getDateInfo.reachTimes[i];
          let id = reachTimeInfo.orderId;
          let cust = this.pointsMap.get(id);
          let showName = ``;
          if (cust.attrs.name) {
            showName = cust.attrs.name;
          } else if (cust.attrs.shopName) {
            showName = cust.attrs.shopName;
          } else if (cust.attrs[`门店名称`]) {
            showName = cust.attrs[`门店名称`];
          }
          this.tableItems.push({
            num: i + 1,
            name: showName,
            arriveTime: reachTimeInfo.time,
            leaveTime: reachTimeInfo.leaveTime
          });
        }
      }
    }
  }
};
</script>
<style lang="less">
.map-layout .with-all-8 {
  width: calc(~"100% - 8px");
}
.wrap-b {
  height: 100%;
  position: relative;
  padding: 8px;
}
.height-200 {
  height: 230px !important;
}
.all-line-info {
  text-align: left;
  font-size: 10px;
  margin: 4px;
}
.font-bold {
  font-weight: bold;
  font-size: 12px !important;
}
.bold {
  font-weight: bold;
}
.with-50 {
  display: inline-block;
  width: 90px;
}
.title-style {
  width: 100px;
  text-align: left;
}
.map-layout .left .ivu-table-wrapper.table-style {
  width: 410px !important;
}
.table-style {
  .ivu-table {
    .ivu-table-overflowX {
      overflow-x: hidden;
    }
    overflow-x: hidden;
    overflow-y: auto !important;
  }
}

.head-style {
  width: calc(~"100% - 436px");
  float: left;
  height: 60px;
  border-bottom: 1px solid #c9d3e0;
  padding-top: 8px;
  padding-left: 16px;
}
.select-condition {
  margin-top: 0 !important;
  height: 52px !important;
  line-height: 52px !important;
}
.margin-top-10 {
  margin-top: 10px !important;
}
.margin-top-8 {
  margin-top: 8px;
}
.margin-right-10 {
  margin-right: 10px;
}
.float-left {
  float: left;
}
.btn-table {
  float: right;
  margin-top: -16px;
}
.title-cont {
  height: 22px;
  line-height: 22px;
  float: left;
  color: #576d8b;
  font-size: 14px;
}
.current-month-heitht {
  height: calc(~"100% - 55px") !important;
}
.height-295 {
  height: calc(~"100% - 295px") !important;
}
.focus-marker-point .way-points {
  background-color: #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DemoMap.vue